const MasterCard = (): JSX.Element => {
  return (
    <svg width="39" height="25" viewBox="0 0 39 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.892578" width="37.5" height="25" rx="4" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9105 17.8719C18.6338 18.943 16.9777 19.5896 15.1681 19.5896C11.1303 19.5896 7.85693 16.3702 7.85693 12.399C7.85693 8.42772 11.1303 5.20837 15.1681 5.20837C16.9777 5.20837 18.6338 5.85499 19.9105 6.92611C21.1872 5.85499 22.8433 5.20837 24.6529 5.20837C28.6907 5.20837 31.9641 8.42772 31.9641 12.399C31.9641 16.3702 28.6907 19.5896 24.6529 19.5896C22.8433 19.5896 21.1872 18.943 19.9105 17.8719Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9104 17.8719C21.4824 16.553 22.4792 14.5905 22.4792 12.399C22.4792 10.2075 21.4824 8.245 19.9104 6.92611C21.1871 5.85499 22.8432 5.20837 24.6528 5.20837C28.6906 5.20837 31.964 8.42772 31.964 12.399C31.964 16.3702 28.6906 19.5896 24.6528 19.5896C22.8432 19.5896 21.1871 18.943 19.9104 17.8719Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9106 17.8718C18.3386 16.5529 17.3418 14.5905 17.3418 12.399C17.3418 10.2075 18.3386 8.24504 19.9106 6.92615C21.4825 8.24504 22.4793 10.2075 22.4793 12.399C22.4793 14.5905 21.4825 16.5529 19.9106 17.8718Z"
        fill="#FF5E00"
      />
    </svg>
  );
};

export default MasterCard;
